/* eslint-disable no-param-reassign,class-methods-use-this */
import api from "Api";

export default {
  install(Vue) {
    Vue.Api = api;
    Vue.prototype.$api = api;
  }
};
